<div class="h-full overflow-auto flex flex-col">
  @if (order.isLoading()) {
    <div class="p-6 text-gray-400">Caricamento...</div>
  } @else if (order.value()) {
    @let o = order.value()!.data;
    <div class="flex justify-between p-4 text-xl font-bold items-center border-b">
      <div class="flex items-center gap-3">
        <a [routerLink]="['..']" class="text-gray-400 hover:text-black text-base">← Ordini</a>
        <span>Ordine #{{ o.id }}</span>
        <span class="text-xs font-semibold px-2 py-1 rounded-full" [class]="statusClass(o.status)">
          {{ statusLabel(o.status) }}
        </span>
      </div>
      <span class="text-base font-normal text-gray-500">{{ o.createdAt | date : 'dd/MM/yyyy HH:mm' }}</span>
    </div>

    <div class="flex-1 overflow-auto p-6 flex flex-col gap-6">

      <!-- Cliente & Indirizzo -->
      <div class="border rounded-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <div class="font-bold text-lg mb-2">Cliente</div>
          <div>{{ $any(o.address)['name'] }} {{ $any(o.address)['surname'] }}</div>
          <div class="text-sm text-gray-500">{{ $any(o.address)['email'] }}</div>
          @if ($any(o.address)['phoneNumber']) {
            <div class="text-sm text-gray-500">{{ $any(o.address)['prefix'] }} {{ $any(o.address)['phoneNumber'] }}</div>
          }
        </div>
        <div>
          <div class="font-bold text-lg mb-2">Indirizzo di spedizione</div>
          <div>{{ $any(o.address)['street'] }} {{ $any(o.address)['streetNumber'] }}</div>
          @if ($any(o.address)['street2']) {
            <div>{{ $any(o.address)['street2'] }}</div>
          }
          <div>{{ $any(o.address)['zipCode'] }} {{ $any(o.address)['city'] }}</div>
          <div>{{ $any(o.address)['country'] }}</div>
        </div>
      </div>

      <!-- Righe ordine -->
      <div class="border rounded-xl overflow-hidden">
        <div class="font-bold text-lg p-4 border-b">Opere acquistate</div>
        <table>
          <thead class="bg-gray-200">
            <tr>
              <th>Anteprima</th>
              <th>Opera</th>
              <th>Artista</th>
              <th>Qty</th>
              <th>Prezzo unitario</th>
              <th>Totale riga</th>
            </tr>
          </thead>
          <tbody>
            @for (row of o.rows; track row.id) {
              <tr [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
                <td>
                  @if (row.artwork.mainAttachment) {
                    <img [src]="row.artwork.mainAttachment.url" class="w-14 h-14 object-cover rounded shadow" />
                  }
                </td>
                <td>
                  <a class="underline hover:opacity-70" [routerLink]="['/backoffice/artworks', row.artwork.id, 'details']">
                    {{ row.artwork.name }}
                  </a>
                </td>
                <td>

                  @if (row.artwork.artist) {
                    <a class="underline hover:opacity-70" [routerLink]="['/backoffice/users', row.artwork.artist.id, 'details']">
                      {{ row.artwork.artist.firstName }} {{ row.artwork.artist.lastName }}
                    </a>
                  }
                </td>
                <td>{{ row.qty }}</td>
                <td>{{ row.price | currency : 'EUR' : '€ ' : '1.2-2' }}</td>
                <td class="font-semibold">{{ (row.price * row.qty) | currency : 'EUR' : '€ ' : '1.2-2' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Riepilogo costi -->
      <div class="border rounded-xl p-4 flex flex-col gap-2 ml-auto w-72">
        <div class="flex justify-between">
          <span class="text-gray-500">Subtotale</span>
          <span>{{ (o.total - o.shippingCosts) | currency : 'EUR' : '€ ' : '1.2-2' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-gray-500">Spedizione</span>
          <span>{{ o.shippingCosts | currency : 'EUR' : '€ ' : '1.2-2' }}</span>
        </div>
        <div class="h-px bg-gray-300 my-1"></div>
        <div class="flex justify-between font-bold text-lg">
          <span>Totale</span>
          <span>{{ o.total | currency : 'EUR' : '€ ' : '1.2-2' }}</span>
        </div>
      </div>

    </div>
  }
</div>
